import { useForm } from 'src/infastruct/effector-react-form'
import {
    $isBasketModalErecipe,
    $isNotRedirectOnCatalog,
    deletePrescriptions,
    prescriptionEnterForm,
    resetIsNotRedirectOnCatalog,
    setIsNotRedirectOnCatalog,
    toggleBasketModalErecipe
} from './model'
import { useEvent, useStore, useStoreMap } from 'effector-react/compat'
import { prescriptionCanUseStatus } from 'src/pages/order/basket/model'

export const usePrescriptionForm = () =>
    useForm({
        form: prescriptionEnterForm
    })

export const usePrescriptionNumbers = () =>
    useStoreMap(prescriptionEnterForm.$values, (state) => {
        const numbers = Object.keys(state.prescriptionNumbers)
        const activeNumber = numbers.filter((key) => !!state.prescriptionNumbers[key])
        if (activeNumber.length === 0) activeNumber.push('0')
        if (activeNumber.length < 10) activeNumber.push(activeNumber.length.toString())
        return activeNumber
    })
export const useIsBasketModalErecipe = () => useStore($isBasketModalErecipe)
export const useToggleBasketModalErecipe = () => useEvent(toggleBasketModalErecipe)
export const useDeletePrescriptions = () => useEvent(deletePrescriptions)

export const useIsNotRedirectOnCatalog = () => useStore($isNotRedirectOnCatalog)
export const useSetIsNotRedirectOnCatalog = () => useEvent(setIsNotRedirectOnCatalog)
export const useResetIsNitRedirectOnCatalog = () => useEvent(resetIsNotRedirectOnCatalog)
export const useCanUseErecipe = () => useStore(prescriptionCanUseStatus.$data)
